<div *ngIf="item && fields">


  <h1 class="h1 mb-5">{{item.navn}}</h1>

  <div *ngIf="item && fields">
    <div class="container-flex">
      <div class="row">
        <div class="col-12 col-md-5 col-lg-4">
          <p style="padding-left:10px;">Navn: {{item.navn}}</p>

        </div>
        <div class="col-12 col-md-5 col-lg-4">
          <app-feltliste [formGroup]="formGroup" [fields]="col2" [modell]="item"></app-feltliste>
        </div>

      </div>


      <div class="row">
        <div class="col-12 col-md-5 col-lg-4">
          <p style="padding-left:10px;">Type: {{item.type}}</p>
        </div>
      </div>

    </div>

  </div>

  <app-tabs #tab [tabs]="tabs" [tabsLoading]="tabsLoading"></app-tabs>
</div>
